import {Service, Module} from 'app/decorators';
import R from 'app/resource';

@Module({
    name: 'app.services.signature',
    modules: [R],
})
@Service('SignatureService')
export default class SignatureService {
    constructor (R) {
        "ngInject";
        this.R = R;
        this.endpoint = this.R.all('signature')
    }

    get () {
        return this.endpoint.post().then((resp) => {
            return resp.signature;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/signature.js